const TOKEN_KEY = "x-token";
const CURRENT_USER_KEY = "current_user";
// Dipakai untuk memicu Header mengambil ulang counter notifikasi tanpa reload.
const NOTIFICATION_REFRESH_EVENT = "notification:refresh";

const PageMode = {
  view: "view",
  add: "add",
  edit: "edit",
  detail: "detail",
};

const Source = {
  COUNTRY: "country",
  PROVINCE: "province",
  DISTRICT: "district",
  SUBDISTRICT: "subdistrict",
  URBANVILLAGE: "urbanvillage",
  FASYANKES: "fasyankes",
};

const UserLevel = {
  Fasyankes: "Fasyankes",
  District: "District",
  Province: "Province",
  National: "National",
  LabTier2: "LabTier2",
  LabTier3: "LabTier3",
  LabTier4: "LabTier4",
  LabTier5: "LabTier5",
  SR: "SR",
  SSR: "SSR",
  BKKWilker: "BKKWilker",
  BKKInduk: "BKKInduk",
  Labkesmas: "Labkesmas",
};

const requestStatus = {
  OK: 200,
  BadRequest: 400,
  Forbidden: 403,
  Conflict: 409,
  ServerError: 500,
};

const ErrorMessage = {
  UserNotVerified:
    "Akun Anda belum terverifikasi, mohon hubungi Administrator untuk pengecekan validasi data dasar atau verifikasi akun",
  UserFaskesNotHaveAccess:
    "Akun Anda belum terverifikasi, mohon hubungi Administrator untuk pengecekan validasi data dasar atau verifikasi akun",
  DataAlreadyExist: "Data yang anda inputkan sudah ada pada sistem",
  InternalServerError: "Terjadi kesalahan di sisi Server",
};

const UserRoles = {
  User: "User",
  Admin: "Admin",
  Viewer: "Viewer",
};

const CadreTupoksiOptions = [
  { label: "Penemuan Kasus", value: "Penemuan Kasus" },
  { label: "Promkes", value: "Promkes" },
  { label: "Surveilans", value: "Surveilans" },
  { label: "Pengendalian Vektor", value: "Pengendalian Vektor" },
  { label: "Lainnya", value: "Lainnya" },
];

const GenderOptions = [
  { label: "Laki Laki", value: "Laki Laki" },
  { label: "Perempuan", value: "Perempuan" },
];

const EducationOptions = [
  { label: "Tidak Tamat SD", value: "Tidak Tamat SD" },
  { label: "Tamat SD", value: "Tamat SD" },
  { label: "SMP", value: "SMP" },
  { label: "SMA", value: "SMA" },
  { label: "Diploma", value: "Diploma" },
  { label: "Sarjana", value: "Sarjana" },
  { label: "Magister", value: "Magister" },
  { label: "Doktor", value: "Doktor" },
];

const OAPOptions = [
  { label: "Orang Asli Papua (OAP)", value: "Orang Asli Papua (OAP)" },
  { label: "Bukan Orang Asli Papua", value: "Bukan Orang Asli Papua" },
];

const YesAndNoOptions = [
  { label: "Ya", value: "Ya" },
  { label: "Tidak", value: "Tidak" },
];

const BrackishWaterOptions = [
  { label: "Ya", value: "Ya" },
  { label: "Tidak", value: "Tidak" },
  { label: "Tidak Diketahui", value: "Tidak Diketahui" },
];

const KohortActivityTypeOptions = [
  { label: "Intervensi Ulang", value: "Intervensi Ulang" },
  { label: "Pasca Intervensi", value: "Pasca Intervensi" },
];

const FeedbackSampleOption = [
  { label: "Baik", value: "Baik" },
  { label: "Kurang Baik (Tidak Layak)", value: "Kurang Baik (Tidak Layak)" },
];

const G6PDResultOptions = [
  { label: "Normal", value: "Normal" },
  { label: "Intermediate", value: "Intermediate" },
  { label: "Defisiensi", value: "Defisiensi" },
];

const PCRResultOptions = [
  { label: "P.Knowlesi terkonfirmasi", value: "P.Knowlesi terkonfirmasi" },
  { label: "P.Vivax", value: "P.Vivax" },
  { label: "P.Falciparum", value: "P.Falciparum" },
  { label: "P.Malariae", value: "P.Malariae" },
  { label: "P.Ovale", value: "P.Ovale" },
  { label: "Negatif Malaria", value: "Negatif Malaria" },
];

const FundSourceCadreOptions = [
  { label: "Global Fund", value: "Global Fund" },
  { label: "APBD", value: "APBD" },
  { label: "Dana Kampung", value: "Dana Kampung" },
  { label: "Lainnya", value: "Lainnya" },
];

const FundSourceCadreTrainingOptions = [
  { label: "APBN", value: "APBN" },
  { label: "APBD", value: "APBD" },
  { label: "Dana Kampung", value: "Dana Kampung" },
  { label: "Global Fund", value: "Global Fund" },
  { label: "Lainnya", value: "Lainnya" },
];

const CadreOriginOptions = [
  { label: "Bukan Perdhaki", value: "Bukan Perdhaki" },
  { label: "Perdhaki", value: "Perdhaki" },
];

const MmpTypeOptions = [
  { label: "Pekerja tambang", value: "Pekerja tambang" },
  { label: "Pekerja hutan", value: "Pekerja hutan" },
  { label: "Pekerja perkebunan", value: "Pekerja perkebunan" },
  {
    label: "Indigenous people/Suku pedalaman/KAT",
    value: "Indigenous people/Suku pedalaman/KAT",
  },
  {
    label: "Pendatang Sementara (TNI, POLRI, Pekerja Migran, dan lainnya)",
    value: "Pendatang Sementara (TNI, POLRI, Pekerja Migran, dan lainnya)",
  },
];

const MonthOptions = [
  { label: "Januari", value: "01" },
  { label: "Februari", value: "02" },
  { label: "Maret", value: "03" },
  { label: "April", value: "04" },
  { label: "Mei", value: "05" },
  { label: "Juni", value: "06" },
  { label: "Juli", value: "07" },
  { label: "Agustus", value: "08" },
  { label: "September", value: "09" },
  { label: "Oktober", value: "10" },
  { label: "November", value: "11" },
  { label: "Desember", value: "12" },
];

export const SampleSendType = {
  SAD: "Sediaan Apusan Darah (SAD)",
  DBS: "Dried Blood Spot (DBS)",
  WB: "Whole Blood EDTA (WB)",
};

const SampleSendTypeOptions = [
  { label: SampleSendType.SAD, value: SampleSendType.SAD },
  { label: SampleSendType.DBS, value: SampleSendType.DBS },
  { label: SampleSendType.WB, value: SampleSendType.WB },
];

const CaseFromOptions = [
  { value: "Faskes Pencatat", label: "Fasyankes Pencatat" },
  { value: "Pustu", label: "Pustu" },
  { value: "Klinik/RS Swasta", label: "Klinik/RS Swasta" },
  {
    value: "DPM/Praktek Bidan/Perawat",
    label: "DPM/Praktek Bidan/Perawat",
  },
  { value: "BKK", label: "BKK" },
  { value: "Perdhaki", label: "Perdhaki" },
  { value: "Pos Kesehatan TNI", label: "Pos Kesehatan TNI" },
  { value: "Lainnya", label: "Lainnya" },
];

const OperatorOptions = [
  { label: "Nakes", value: "Nakes" },
  { label: "Kader", value: "Kader" },
];

const PregnancyStatusOptions = [
  { label: "Hamil", value: "Hamil" },
  { label: "Tidak Hamil", value: "Tidak Hamil" },
  { label: "Menyusui Bayi < 1 Bulan", value: "Menyusui Bayi < 1 Bulan" },
];

const AgeTypeOptions = [
  { label: "Tahun", value: "Tahun" },
  { label: "Bulan", value: "Bulan" },
];

const JobsListOptions = [
  { value: "Nelayan", label: "Nelayan" },
  { value: "Petani", label: "Petani" },
  { value: "Buruh Tambang", label: "Buruh Tambang" },
  { value: "Ibu Rumah Tangga", label: "Ibu Rumah Tangga" },
  { value: "Pegawai", label: "Pegawai" },
  { value: "TNI", label: "TNI" },
  { value: "POLRI", label: "POLRI" },
  { value: "Berkebun", label: "Berkebun" },
  { value: "Perambah Hutan", label: "Perambah Hutan" },
  { value: "Pedagang", label: "Pedagang" },
  { value: "Pelajar", label: "Pelajar" },
  { value: "Tidak Bekerja", label: "Tidak Bekerja" },
  { value: "Lainnya", label: "Lainnya" },
];

const SymthomaticOptions = [
  { value: "Demam", label: "Demam" },
  { value: "Lainnya", label: "Gejala Lainnya" },
  { value: "Tidak bergejala", label: "Tidak bergejala" },
];

const StandarMedicationReasonOptions = [
  { value: "Tidak tersedia obat", label: "Tidak tersedia obat" },
  { value: "Pasien menolak diobati", label: "Pasien menolak diobati" },
  { value: "Pasien dirujuk", label: "Pasien dirujuk" },
  { value: "Lainnya", label: "Lainnya" },
];

const RegmalCaseFromOptions = [
  { value: "Faskes Pencatat", label: "Fasyankes Pencatat" },
  { value: "Pustu", label: "Pustu" },
  { value: "Klinik/RS Swasta", label: "Klinik/RS Swasta" },
  {
    value: "DPM/Praktek Bidan/Perawat",
    label: "DPM/Praktek Bidan/Perawat",
  },
  { value: "BKK", label: "BKK" },
  { value: "Perdhaki", label: "Perdhaki" },
  { value: "Pos Kesehatan TNI", label: "Pos Kesehatan TNI" },
  { value: "Lainnya", label: "Lainnya" },
];

const LabCheckingOptions = [
  { value: "Mikroskop", label: "Mikroskop" },
  { value: "RDT", label: "RDT" },
  { value: "Tanpa Pemeriksaan", label: "Tanpa Pemeriksaan" },
];

const LabCheckingOptionsRujukan = [
  { value: "Mikroskop", label: "Mikroskop" },
  { value: "RDT", label: "RDT" },
];

const DiseaseDegreeOptions = [
  { value: "Tanpa Komplikasi", label: "Tanpa Komplikasi" },
  {
    value: "Komplikasi (Malaria Berat)",
    label: "Komplikasi (Malaria Berat)",
  },
];

const GametositOptions = [
  { value: "Positif", label: "Positif" },
  { value: "Negatif", label: "Negatif" },
];

const MedicationStatusOptions = [
  { label: "Standard", value: "Standard" },
  { label: "Tidak Standard", value: "Tidak Standard" },
  { label: "Presumtif", value: "Presumtif" },
];

const TreatmentOptions = [
  { value: "Rawat Jalan", label: "Rawat Jalan" },
  { value: "Rawat Inap", label: "Rawat Inap" },
];

const ParasyteOptions = [
  { label: "P.falciparum", value: "P.Falciparum" },
  { label: "P.malariae", value: "P.Malariae" },
  { label: "Probable knowlesi", value: "Probable Knowlesi" },
  { label: "P.vivax", value: "P.Vivax" },
  { label: "P.ovale", value: "P.Ovale" },
  { label: "P.mix", value: "P.Mix" },
];

const RecurrenceOptions = [
  { label: "Baru", value: "Baru" },
  { label: "Relaps", value: "Relaps" },
];

const LogisticInputStockOptions = [
  { value: "DHP Dispersible", label: "DHP Dispersible" },
  { value: "DHP (Tablet)", label: "DHP (Tablet)" },
  { value: "Primaquin (Tablet)", label: "Primaquin (Tablet)" },
  { value: "Artesunat Inj (Vial)", label: "Artesunat Inj (Vial) " },
  { value: "Kina (Tablet)", label: "Kina (Tablet)" },
  { value: "Kina Inj (Ampul)", label: "Kina Inj (Ampul)" },
  { value: "Doksisiklin (Tablet)", label: "Doksisiklin (Tablet)" },
  { value: "RDT (Test)", label: "RDT (Test)" },
  { value: "LLIN (Lembar)", label: "LLIN (Lembar)" },
  { value: "Insektisida (Kg)", label: "Insektisida (Kg)" },
  { value: "Insektisida (Liter)", label: "Insektisida (Liter)" },
  { value: "Larvasida (Kg)", label: "Larvasida (Kg)" },
  { value: "Larvasida (Liter)", label: "Larvasida (Liter)" },
  { value: "Lab Kit (Paket)", label: "Lab Kit (Paket)" },
  { value: "Giemsa (CC)", label: "Giemsa (CC)" },
  { value: "Minyak Imersi (CC)", label: "Minyak Imersi (CC)" },
  { value: "Blood Slide (Box)", label: "Blood Slide (Box)" },
  { value: "Slide Box (Buah)", label: "Slide Box (Buah)" },
  { value: "Blood Lancet (Box)", label: "Blood Lancet (Box)" },
  { value: "Methanol (CC)", label: "Methanol (CC)" },
  { value: "Spray Can (Buah)", label: "Spray Can (Buah)" },
  { value: "Mist Blower (Buah)", label: "Mist Blower (Buah)" },
  {
    value: "Microscope Binocular (Buah)",
    label: "Microscope Binocular (Buah)",
  },
  {
    value: "Microscope Trinocular (Buah)",
    label: "Microscope Trinocular (Buah)",
  },
  {
    value: "Microscope Teaching (Buah)",
    label: "Microscope Teaching (Buah)",
  },
];

const LogisticInputStockOptionsNonPKM = [
  { value: "DHP Dispersible", label: "DHP Dispersible" },
  { value: "DHP (Tablet)", label: "DHP (Tablet)" },
  { value: "Primaquin (Tablet)", label: "Primaquin (Tablet)" },
  { value: "Artesunat Inj (Vial)", label: "Artesunat Inj (Vial) " },
  { value: "Kina (Tablet)", label: "Kina (Tablet)" },
  { value: "Kina Inj (Ampul)", label: "Kina Inj (Ampul)" },
  { value: "Doksisiklin (Tablet)", label: "Doksisiklin (Tablet)" },
  { value: "RDT (Test)", label: "RDT (Test)" },
  { value: "Lab Kit (Paket)", label: "Lab Kit (Paket)" },
  { value: "Giemsa (CC)", label: "Giemsa (CC)" },
  { value: "Minyak Imersi (CC)", label: "Minyak Imersi (CC)" },
  { value: "Blood Slide (Box)", label: "Blood Slide (Box)" },
  { value: "Slide Box (Buah)", label: "Slide Box (Buah)" },
  { value: "Blood Lancet (Box)", label: "Blood Lancet (Box)" },
  { value: "Methanol (CC)", label: "Methanol (CC)" },
  {
    value: "Microscope Binocular (Buah)",
    label: "Microscope Binocular (Buah)",
  },
];

const TypeBreedingPlaceOptions = [
  { label: "Kolam", value: "Kolam" },
  { label: "Bak Air", value: "Bak Air" },
  { label: "Parit", value: "Parit" },
  { label: "Bekas Galian", value: "Bekas Galian" },
  { label: "Kubangan", value: "Kubangan" },
  { label: "Bekas Ban", value: "Bekas Ban" },
  { label: "Rawa", value: "Rawa" },
  { label: "Sawah", value: "Sawah" },
  { label: "Lagun", value: "Lagun" },
  { label: "Kali/Sungai", value: "Kali/Sungai" },
  { label: "Genangan Air", value: "Genangan Air" },
  { label: "Lainnya, Sebutkan", value: "Lainnya" },
];

const TraitBreedingOptions = [
  { label: "Permanen", value: "Permanen" },
  { label: "Sementara", value: "Sementara" },
];

const LarvacideTypeOptions = [
  { label: "Biolarvasida", value: "Biolarvasida" },
  {
    label: "IGR/Juvenile Hormone",
    value: "IGR/Juvenile Hormone",
  },
  { label: "Organophosphate", value: "Organophosphate" },
  { label: "Benzoilurea", value: "Benzoilurea" },
];

const LarvacideFormOptions = [
  { label: "Cair", value: "Cair" },
  { label: "Bubuk/Serbuk", value: "Bubuk/Serbuk" },
  { label: "Granul", value: "Granul" },
  { label: "Briket", value: "Briket" },
  { label: "Tablet", value: "Tablet" },
  { label: "Pelet", value: "Pelet" },
  { label: "Lainnya", value: "Lainnya" },
];

const StatusTpOptions = [
  { label: "Masih Ada", value: "Masih Ada" },
  { label: "Tidak Ada", value: "Tidak Ada" },
];

const TpGoneReasonOptions = [
  { label: "Karena Intervensi", value: "Karena Intervensi" },
  { label: "Bukan Karena Intervensi", value: "Bukan Karena Intervensi" },
];

const UnitOptions = [
  { label: "Kg", value: "Kg" },
  { label: "Liter", value: "Liter" },
];

const SpeciesMosquitoOptions = [
  {
    label: "An. barbirostris",
    value: "An. barbirostris",
    variable: "barbirostris",
  },
  { label: "An. aconitus", value: "An. aconitus", variable: "aconitus" },
  { label: "An. bancrofti", value: "An. bancrofti", variable: "bancrofti" },
  {
    label: "An. balabacensis",
    value: "An. balabacensis",
    variable: "balabacensis",
  },
  { label: "An. farauti", value: "An. farauti", variable: "farauti" },
  {
    label: "An. flavirostris",
    value: "An. flavirostris",
    variable: "flavirostris",
  },
  { label: "An. koliensis", value: "An. koliensis", variable: "koliensis" },
  { label: "An. letifer", value: "An. letifer", variable: "letifer" },
  { label: "An. lodiowae", value: "An. lodiowae", variable: "lodiowae" },
  { label: "An. maculatus", value: "An. maculatus", variable: "maculatus" },
  { label: "An. minimus", value: "An. minimus", variable: "minimus" },
  {
    label: "An. punctulatus",
    value: "An. punctulatus",
    variable: "punctulatus",
  },
  { label: "An. nigerrimus", value: "An. nigerrimus", variable: "nigerrimus" },
  { label: "An. sinensis", value: "An. sinensis", variable: "sinensis" },
  { label: "An. subpictus", value: "An. subpictus", variable: "subpictus" },
  { label: "An. sundaicus", value: "An. sundaicus", variable: "sundaicus" },
  { label: "An. annularis", value: "An. annularis", variable: "annularis" },
  {
    label: "An. barbumbrosus",
    value: "An. barbumbrosus",
    variable: "barbumbrosus",
  },
  { label: "An. karwari", value: "An. karwari", variable: "karwari" },
  { label: "An. kochi", value: "An. kochi", variable: "kochi" },
  {
    label: "An. leucosphyrus",
    value: "An. leucosphyrus",
    variable: "leucosphyrus",
  },
  {
    label: "An. parangensis",
    value: "An. parangensis",
    variable: "parangensis",
  },
  { label: "An. umbrosus", value: "An. umbrosus", variable: "umbrosus" },
  { label: "An. vagus", value: "An. vagus", variable: "vagus" },
  { label: "An. tessalatus", value: "An. tessalatus", variable: "tessalatus" },
  {
    label: "An. peditaeniatus",
    value: "An. peditaeniatus",
    variable: "peditaeniatus",
  },
  {
    label: "Anopheles Lainnya",
    value: "Anopheles Lainnya",
    variable: null,
  },
];

const indicatorAnalysisOptions = [
  {
    label: "Jumlah Kasus Positif",
    value: "indikator_2",
  },
  {
    label: "Jumlah Kasus Positif Per Desa Domisili",
    value: "indikator_30",
  },
  {
    label: "Jumlah Kasus Kematian",
    value: "indikator_20",
  },
  {
    label: "Jumlah Pemeriksaan",
    value: "indikator_7",
  },
  {
    label: "Jumlah Kasus Indigenous",
    value: "indikator_13",
  },
  {
    label: "Annual Parasite Incidence (API)",
    value: "indikator_24",
  },
  {
    label: "Annual Blood Examination Rate (ABER)",
    value: "indikator_5",
  },
  {
    label: "% Kelengkapan Laporan",
    value: "indikator_1",
  },
  {
    label: "% Konfirmasi Laboratorium Malaria",
    value: "indikator_4",
  },
  {
    label: "% Pengobatan Standar Malaria",
    value: "indikator_11",
  },
  {
    label: "% Positivity Rate Malaria",
    value: "indikator_10",
  },
  {
    label: "% Notifikasi Kasus Positif yang Dilakukan PE",
    value: "indikator_15",
  },
  {
    label: "% Ketepatan PE",
    value: "indikator_25",
  },
  {
    label: "% Kasus Indigenous yang Tervalidasi",
    value: "indikator_6",
  },
  {
    label: "% Kelengkapan Laporan Logistik Malaria",
    value: "indikator_14",
  },
  {
    label: "% Fasyankes yang Melapor Tidak Putus Stok",
    value: "indikator_19",
  },
  {
    label: "% Ketepatan Laporan (Wilayah dengan API < 1)",
    value: "indikator_9",
  },
  {
    label: "% Ketepatan Laporan (Wilayah dengan API > 1)",
    value: "indikator_8",
  },
  {
    label: "% Keaktifan Kinerja Kader Berdasarkan Kunjungan Rumah",
    value: "indikator_23",
  },
  {
    label: "% Keaktifan Kinerja Kader Berdasarkan Pemeriksaan",
    value: "indikator_23A",
  },
  {
    label: "Tren Kasus Kematian",
    value: "indikator_3",
  },
  {
    label: "Tren SKD Malaria",
    value: "indikator_16",
  },
  {
    label: "Proporsi Jenis Plasmodium",
    value: "indikator_12",
  },
  {
    label: "Proporsi Berdasarkan Penemuan Kasus",
    value: "indikator_17",
  },
  {
    label: "Proporsi Kasus Positif Berdasarkan Kepemilikan",
    value: "indikator_18",
  },
  {
    label: "Proporsi Penemuan Kasus berdasarkan Jenis Petugas",
    value: "indikator_21",
  },
  {
    label: "Proporsi berdasarkan Klasifikasi Kasus",
    value: "indikator_22",
  },
  {
    label: "Proporsi Berdasarkan Jenis Mobile Migrant Population (MMP)",
    value: "indikator_27",
  },
  {
    label: "Tren Bulanan Pemantauan Jentik",
    value: "indikator_31",
  },
  // indikator_32 "Tren Harian Pemantauan Jentik" hidden from Analisis;
  // it is being moved to the Laporan module instead.
  // {
  //   label: "Tren Harian Pemantauan Jentik (per Tanggal Kunjungan)",
  //   value: "indikator_32",
  // },
];

const TrainingProvidingInstitutionsOptions = [
  { label: "Dinkes Provinsi", value: "1" },
  { label: "Dinkes Kab/Kota", value: "2" },
  { label: "Kemenkes", value: "3" },
  { label: "Patelki", value: "4" },
  { label: "Labkesmas", value: "5" },
  { label: "WHO", value: "6" },
  { label: "Lainnya", value: "7" },
];

const NumberOfMicroscopicTrainingOptions = [
  { label: "0", value: 0 },
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
  { label: "4", value: 4 },
  { label: "5", value: 5 },
  { label: "6", value: 6 },
  { label: "7", value: 7 },
  { label: "8", value: 8 },
  { label: "9", value: 9 },
  { label: "10", value: 10 },
];

const YesAndNoTrainingValueOptions = [
  { label: "Ya = Dengan Nilai", value: "Ya" },
  { label: "Tidak = Tanpa Nilai", value: "Tidak" },
];

const YesAndNoTestPanelOptions = [
  { label: "Ya = Bimtek Dengan Uji Panel", value: "Ya" },
  { label: "Tidak = Bimtek Tanpa Uji Panel", value: "Tidak" },
];

const ProficiencyTestingInstitutionOptions = [
  { label: "Balai Besar Binomika", value: "1" },
  { label: "Balai Besar Labkesmas Surabaya", value: "2" },
  { label: "Balai Besar Labkesmas Palembang", value: "3" },
  { label: "Balai Besar Labkesmas Makassar", value: "4" },
  { label: "Lainnya", value: "5" },
];

const TypeofCompetencyTestOptions = [
  { label: "ECAMM", value: "ECAMM" },
  { label: "NCAMM", value: "NCAMM" },
];

const CompetencyTestResultsFasyankesOptions = [
  { label: "Level-1", value: "1" },
  { label: "Level-2", value: "2" },
  { label: "Level-3", value: "3" },
  { label: "Level-4", value: "4" },
];
const CompetencyTestResultsOptions = [
  { label: "Level-1", value: "1" },
  { label: "Level-2", value: "2" },
  { label: "Level-3", value: "3" },
  { label: "Level-4", value: "4" },
  { label: "Level-A", value: "5" },
  { label: "Level-B", value: "6" },
  { label: "Level-C", value: "7" },
  { label: "Level-D", value: "8" },
];

const EmployeeStatusOptions = [
  { label: "ASN", value: 1 },
  { label: "Non ASN", value: 2 },
];

const RDTBrandOptions = [
  {
    label: "First Response Malaria Ag pLDH/HRP2 Combo",
    value: "R01",
  },
  {
    label: "CareStart Malaria HRP2/pLDH (Pf/PAN) COMBO",
    value: "R02",
  },
  { label: "SD BIOLINE Ag Pf/Pan", value: "R03" },
  { label: "Lainnya", value: "R04" },
];

const UserLevelOptions = [
  {
    label: "Fasyankes",
    value: "Fasyankes",
  },
  { label: "Kabupaten/Kota", value: "District" },
  { label: "Provinsi", value: "Province" },
  { label: "Nasional/Pusat", value: "National" },
  { label: "Lab Tingkat 2", value: "LabTier2" },
  { label: "Lab Tingkat 3", value: "LabTier3" },
  { label: "Lab Tingkat 4", value: "LabTier4" },
  { label: "Lab Tingkat 5", value: "LabTier5" },
  { label: "BKK Induk", value: "BKKInduk" },
  { label: "BKK Wilker", value: "BKKWilker" },
  { label: "Labkesmas", value: "Labkesmas" },
];

const WorkspaceOptions = [
  {
    label: "Fasyankes",
    value: "1",
  },
  {
    label: "Dinkes",
    value: "2",
  },
  {
    label: "B-BLK",
    value: "3",
  },
  {
    label: "B-BTKL",
    value: "4",
  },
  {
    label: "BLK-Labkesda",
    value: "5",
  },
  {
    label: "Lainnya",
    value: "6",
  },
];

const YesAndNoOtherOptions = [
  { label: "Ya", value: "1" },
  { label: "Tidak", value: "2" },
];

const LastEducationOptions = [
  {
    label: "SMA/Sederajat",
    value: 1,
  },
  {
    label: "DIII/DIV/S1 ATLM",
    value: 2,
  },
  { label: "DIII/DIV/S1 Non ATLM", value: 4 },
  // {
  //   label: "Non ATLM",
  //   value: 3,
  // },
];

const KualitasPewarnaanOptions = [
  { label: "Normal", value: "Normal" },
  { label: "Asam", value: "Asam" },
  { label: "Basa", value: "Basa" },
  { label: "Kotor", value: "Kotor" },
];

const KetebalanSDOptions = [
  { label: "Cukup", value: "Cukup" },
  { label: "Tebal", value: "Tebal" },
  { label: "Tipis", value: "Tipis" },
];

const HasilUjiSilangOptions = [
  ...ParasyteOptions,
  { label: "Negatif", value: "Negatif" },
];

export {
  KualitasPewarnaanOptions,
  KetebalanSDOptions,
  HasilUjiSilangOptions,
  TOKEN_KEY,
  NOTIFICATION_REFRESH_EVENT,
  CURRENT_USER_KEY,
  PageMode,
  Source,
  UserLevel,
  ErrorMessage,
  UserRoles,
  requestStatus,
  CadreTupoksiOptions,
  GenderOptions,
  EducationOptions,
  OAPOptions,
  YesAndNoOptions,
  BrackishWaterOptions,
  KohortActivityTypeOptions,
  G6PDResultOptions,
  FundSourceCadreOptions,
  CadreOriginOptions,
  MmpTypeOptions,
  MonthOptions,
  SampleSendTypeOptions,
  CaseFromOptions,
  OperatorOptions,
  PregnancyStatusOptions,
  JobsListOptions,
  SymthomaticOptions,
  StandarMedicationReasonOptions,
  RegmalCaseFromOptions,
  LabCheckingOptions,
  DiseaseDegreeOptions,
  GametositOptions,
  MedicationStatusOptions,
  TreatmentOptions,
  ParasyteOptions,
  RecurrenceOptions,
  LogisticInputStockOptions,
  LogisticInputStockOptionsNonPKM,
  LabCheckingOptionsRujukan,
  AgeTypeOptions,
  TypeBreedingPlaceOptions,
  TraitBreedingOptions,
  LarvacideTypeOptions,
  LarvacideFormOptions,
  StatusTpOptions,
  TpGoneReasonOptions,
  UnitOptions,
  SpeciesMosquitoOptions,
  indicatorAnalysisOptions,
  TrainingProvidingInstitutionsOptions,
  NumberOfMicroscopicTrainingOptions,
  YesAndNoTrainingValueOptions,
  YesAndNoTestPanelOptions,
  ProficiencyTestingInstitutionOptions,
  TypeofCompetencyTestOptions,
  CompetencyTestResultsOptions,
  EmployeeStatusOptions,
  RDTBrandOptions,
  UserLevelOptions,
  WorkspaceOptions,
  LastEducationOptions,
  YesAndNoOtherOptions,
  CompetencyTestResultsFasyankesOptions,
  PCRResultOptions,
  FundSourceCadreTrainingOptions,
  FeedbackSampleOption,
};
